import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

import { contractsLoadDocParticipants } from './actions'

function mapStateToProps(state, hocProps) {
    const module = _.get(hocProps, 'module', null)
    const entId = _.get(hocProps, 'entId', null)
    const docId = _.get(hocProps, 'docId', null)
    const blockKey = _.get(hocProps, 'block', null)

    return {
        participants: state.getIn([
            'ui',
            'workspace',
            module,
            entId,
            'blocks',
            blockKey,
            'customData',
            'participants',
            docId,
            'data',
        ]),
        isLoading: state.getIn([
            'ui',
            'workspace',
            module,
            entId,
            'blocks',
            blockKey,
            'customData',
            'participants',
            docId,
            'isLoading',
        ]),
        dataLocale: state.getIn([
            'ui',
            'workspace',
            module,
            entId,
            'blocks',
            blockKey,
            'customData',
            'participants',
            docId,
            'dataLocale',
        ]),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            contractsLoadDocParticipants,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
